import backendV2Service from './backend-v2.service';

export interface CreateStudentPayload {
  firstname: string;
  lastname: string;
  lastname2nd?: string;
  dni: string;
  email?: string;
  birthDate: string; // YYYY-MM-DD → wire: birth_date
  baseCountryId: number; // → base_country_id
  schoolId: number; // → school_id
  courseId: number; // → course_id
}

export interface CreateStudentResult {
  status: string;
  content: { id: number; username: string; passwordTmp: string };
}

export interface CreateIndependentStudentPayload {
  firstName: string; // → first_name
  lastName: string; // → last_name
  email?: string;
  grade: number | null; // 0..12 o null (se elige en el onboarding)
  countryId: number; // → country_id
  timeZone?: string; // IANA → time_zone
}

export interface CreateIndependentStudentResult {
  id: number;
  username: string;
  password: string;
}

const unwrap = <T>(req: Promise<{ data: T }>) => req.then(({ data }) => data);

export default {
  create: (payload: CreateStudentPayload): Promise<CreateStudentResult> => unwrap(
    backendV2Service.post<CreateStudentResult>('/students', payload),
  ),

  // Contrato C7: el body sale en snake_case por el transform normal de backendV2Service.
  createIndependent: (
    payload: CreateIndependentStudentPayload,
  ): Promise<CreateIndependentStudentResult> => {
    const { email, timeZone, ...required } = payload;
    return unwrap(backendV2Service.post<CreateIndependentStudentResult>(
      '/internal/independent-students',
      {
        ...required,
        ...(email ? { email } : {}),
        ...(timeZone ? { timeZone } : {}),
      },
    ));
  },
};
